import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import api from "@/lib/api";

// Sélection de la personne qui a AVANCÉ l'argent (tous les résidents actifs,
// président et trésorier inclus) + CONFIRMATION explicite du nom choisi.
export const AdvancePicker = ({ t, value, confirmed, onPick, onConfirm, testidPrefix = "adv" }) => {
  const [people, setPeople] = useState([]);
  useEffect(() => {
    api.get("/expenses/advance-people").then((r) => setPeople(r.data)).catch(() => {});
  }, []);
  const selected = people.find((p) => p.id === value);
  return (
    <div className="space-y-2">
      <label className="text-sm font-semibold text-muted-foreground">{t("advance_by_select")}</label>
      <select value={value || ""} onChange={(e) => onPick(e.target.value)} data-testid={`${testidPrefix}-advance-person`}
        className="w-full h-11 rounded-xl border border-input bg-background px-3 outline-none">
        <option value="">—</option>
        {people.map((p) => (
          <option key={p.id} value={p.id}>{p.name} · {t("role_" + p.role)}</option>
        ))}
      </select>
      {selected && (
        <div className="rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/50 p-3 flex items-center justify-between gap-2" data-testid={`${testidPrefix}-advance-confirm-box`}>
          <p className="text-sm text-amber-800 dark:text-amber-300 min-w-0">
            {t("advanced_by_label")} : <b data-testid={`${testidPrefix}-advance-name`}>{selected.name}</b>
          </p>
          <button onClick={() => onConfirm(!confirmed)} data-testid={`${testidPrefix}-advance-confirm-btn`}
            className={`h-9 px-3 rounded-lg text-xs font-bold flex items-center gap-1 shrink-0 transition-colors ${confirmed ? "bg-emerald-600 text-white" : "border border-amber-400 text-amber-700 dark:text-amber-300"}`}>
            {confirmed ? <><Icons.Check className="h-3.5 w-3.5" /> {t("advance_confirmed")}</> : t("advance_confirm_label")}
          </button>
        </div>
      )}
    </div>
  );
};
